import { InvalidBirthYearError } from '../errors/InvalidBirthYearError';

const initBirthYear = 1950;

export const createInitBirthYearList = (): number[] => {
  const startYear = initBirthYear;

  const endYear = new Date().getFullYear();

  const birthYearList = [];

  // eslint-disable-next-line id-length, no-plusplus
  for (let i = startYear; i <= endYear; i++) {
    birthYearList.push(i);
  }

  return birthYearList;
};

// eslint-disable-next-line no-magic-numbers
const birthMonthList = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] as const;

export type BirthMonth = (typeof birthMonthList)[number];

export const createInitBirthMonthList = (): Readonly<BirthMonth[]> =>
  birthMonthList;

export const initBirthday = 1;

const defaultEndDay = 31;

const createDayList = (endDay: number = defaultEndDay): number[] => {
  const startDay = initBirthday;

  const birthdayList = [];

  // eslint-disable-next-line id-length, no-plusplus
  for (let i = startDay; i <= endDay; i++) {
    birthdayList.push(i);
  }

  return birthdayList;
};

// 誕生年と誕生月から日付のリストを生成する
export const createBirthdayList = (
  birthYear: number,
  birthMonth: BirthMonth,
): number[] => {
  const birthYearList = createInitBirthYearList();
  if (!birthYearList.includes(birthYear)) {
    throw new InvalidBirthYearError();
  }

  const lastDayOfTheMonth = new Date(
    birthYear,
    birthMonth,
    // eslint-disable-next-line no-magic-numbers
    0,
  ).getDate();

  return createDayList(lastDayOfTheMonth);
};

type CreateBirthdateRequest = {
  birthYear: number;
  birthMonth: number;
  birthday: number;
};

export type Birthdate = `${string}-${string}-${string}`;

export const createBirthdate = (request: CreateBirthdateRequest): Birthdate => {
  const paddingLength = 2;

  return `${request.birthYear}-${String(request.birthMonth).padStart(
    paddingLength,
    '0',
  )}-${String(request.birthday).padStart(paddingLength, '0')}`;
};
